import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { CheckCircle2, Clock, XCircle, Loader2 } from "lucide-react";

export function PilotDecisionDialog({
  open, onOpenChange, pilot, decisionData, setDecisionData, onConfirm, loading,
}) {
  const options = [
    { value: "scale", label: "Escalar", icon: CheckCircle2, color: "text-green-600" },
    { value: "extend", label: "Extender", icon: Clock, color: "text-amber-600" },
    { value: "discard", label: "Descartar", icon: XCircle, color: "text-red-600" },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Decisión de Cierre de Piloto</DialogTitle>
          <DialogDescription>Registra la decisión final para &ldquo;{pilot?.name}&rdquo;</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-3 gap-2">
            {options.map(opt => (
              <Button
                key={opt.value}
                variant={decisionData.decision === opt.value ? "default" : "outline"}
                className="flex flex-col h-auto py-4"
                onClick={() => setDecisionData({ ...decisionData, decision: opt.value })}
              >
                <opt.icon className={`w-6 h-6 mb-1 ${opt.color}`} />
                <span>{opt.label}</span>
              </Button>
            ))}
          </div>
          <div className="space-y-2">
            <Label htmlFor="decision-notes">Notas de decisión</Label>
            <Textarea
              id="decision-notes"
              value={decisionData.notes}
              onChange={(e) => setDecisionData({ ...decisionData, notes: e.target.value })}
              placeholder="Justificación de la decisión..."
              rows={3}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={onConfirm} disabled={loading}>
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Confirmar Decisión
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
